import React from 'react';
import { WidgetId } from '../../../../api/useWidgetsQuery';
import { MarketValueCard } from '../../widgets/MarketValueCard/MarketValueCard';
import { PeriodReturnCard } from '../../widgets/PeriodReturnCard/PeriodReturnCard';
import { ActivitySummaryCard } from '../../widgets/ActivitySummaryCard/ActivitySummaryCard';
import { ValueVsInvestmentCard } from '../../widgets/ValueVsInvestmentCard/ValueVsInvestmentCard';
import { AssetAllocationCard } from '../../widgets/AssetAllocationCard/AssetAllocationCard';
import { PerformanceSummaryCard } from '../../widgets/PerformanceSummaryCard/PerformanceSummaryCard';
import { PerformanceVsBenchmarkCard } from '../../widgets/PerformanceVsBenchmarkCard/PerformanceVsBenchmarkCard';
import { PerformanceDetailsCard } from '../../widgets/PerformanceDetailsCard/PerformanceDetailsCard';
import { ProjectedIncomeCard } from '../../widgets/ProjectedIncomeCard/ProjectedIncomeCard';
import { IncomeDetailsCard } from '../../widgets/IncomeDetailsCard/IncomeDetailsCard';
import { PerformanceChartCard } from '../../widgets/PerformanceChartCard/PerformanceChartCard';

interface Props {
  id: WidgetId;
  title: string;
}

export const WidgetContent = ({ id, title }: Props) => {
  if (id === 'market-value') {
    return <MarketValueCard />;
  }

  if (id === 'return') {
    return <PeriodReturnCard />;
  }

  if (id === 'activity-summary') {
    return <ActivitySummaryCard title={title} />;
  }

  if (id === 'pv-vs-nai') {
    return <ValueVsInvestmentCard title={title} />;
  }

  if (id === 'allocation-slot-a') {
    return <AssetAllocationCard tab="left" />;
  }

  if (id === 'allocation-slot-b') {
    return <AssetAllocationCard tab="right" />;
  }

  if (id === 'performance-summary') {
    return <PerformanceSummaryCard title={title} />;
  }

  if (id === 'performance-vs-benchmark') {
    return <PerformanceVsBenchmarkCard />;
  }

  if (id === 'performance-details') {
    return <PerformanceDetailsCard title={title} id={id} />;
  }

  if (id === 'projected-income') {
    return <ProjectedIncomeCard title={title} />;
  }

  if (id === 'income-details') {
    return <IncomeDetailsCard title={title} id={id} />;
  }

  if (id === 'performance-chart') {
    return <PerformanceChartCard title={title} id={id} />;
  }

  return null;
};
